export default {
  bendRangeMin:  [64, 58, 53, 48, 43, 37, 32, 27,  22,  16,  11,  6,   0],
  bendRangeMax:  [64, 69, 74, 79, 85, 90, 95, 100, 106, 111, 116, 121, 127]
}
